import React from 'react';
import { func, bool, string } from 'prop-types';

import CarouselGallery from '../carousel-gallery';

const Video = ({ youtubeLink, openDialog, closeDialog, isDialogOpen }) => (
    <CarouselGallery
        mediaLinks={[{ link: youtubeLink, type: 'video' }]}
        openDialog={openDialog}
        closeDialog={closeDialog}
        isDialogOpen={isDialogOpen}
        trackingContext="VIPImages"
    />
);

Video.propTypes = {
    closeDialog: func,
    isDialogOpen: bool,
    openDialog: func,
    youtubeLink: string.isRequired,
};

Video.defaultProps = {
    closeDialog: () => {},
    isDialogOpen: false,
    openDialog: () => {},
};

export default Video;
